<template>
  <div class="top3 pt-3">
    <div class="row g-0">
      <div class="col-12 col-md-8">
        <div class="row g-0">
          <div
            v-for="card in topCards"
            :key="getCardInstanceId(card)"
            class="col-12 col-md-12 col-lg-4 mb-3"
          >
            <div
              class="card top-three-product-card"
              :class="{ 'is-flipped': isTopCardFlipped(card.type) }"
            >
              <div class="card-front d-flex flex-column">
                <div class="ribbon-wrapper">
                  <div class="ribbon">{{ card.ribbon }}</div>
                </div>

                <div class="cardHead my-2">
                  <h5 class="card-title text-start mt-3 mx-2">
                    {{ card.product.amazonNamenSuche }}
                  </h5>
                </div>

                <div class="top-three-carousel">
                  <pic-carousel
                    :key="'carousel-' + getCardInstanceId(card)"
                    :product="card.product"
                    :instance-id="'carousel-' + getCardInstanceId(card)"
                  />
                </div>

                <div class="card-body d-flex flex-column pb-0">
                  <div class="chart-container d-flex justify-content-center align-items-center">
                    <canvas :id="'chart-' + getCardInstanceId(card)"></canvas>
                  </div>

                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Größe</span>
                        </div>
                        <div>
                          <span class="ml-2" v-if="card.product.diagonale">
                            {{ card.product.diagonale }} Zoll
                          </span>
                          <span class="ml-2" v-else>Keine Information</span>
                        </div>

                        <div>
                          <span class="label-data-front mx-2">Display</span>
                        </div>
                        <div>
                          <span
                            class="ml-2"
                            v-if="card.product.paneltech === null || card.product.paneltech === undefined || card.product.paneltech === ''"
                          >
                            Keine Information
                          </span>
                          <span class="ml-2" v-else>{{ card.product.paneltech }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-lg-6">
                      <div class="d-flex flex-column">
                        <div>
                          <span class="label-data-front mx-2">Auflösung</span>
                        </div>
                        <div>
                          <span
                            class="ml-2"
                            v-if="card.product.horizontalpixel && card.product.vertikalpixel"
                          >
                            {{ card.product.horizontalpixel }}x{{ card.product.vertikalpixel }}
                          </span>
                          <span class="ml-2" v-else>Keine Information</span>
                        </div>

                        <div>
                          <span class="label-data-front mx-2">Frequenz</span>
                        </div>
                        <div>
                          <span
                            class="ml-2"
                            v-if="card.product.frequenzvertikal_merged === '0.00' || card.product.frequenzvertikal_merged === 0 || card.product.frequenzvertikal_merged == null || isNaN(Number(card.product.frequenzvertikal_merged))"
                          >
                            Keine Information
                          </span>
                          <span class="ml-2" v-else>
                            {{ card.product.frequenzvertikal_merged }} Hz
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    class="datasheet-button mt-3 mb-3 align-self-center py-1 px-3"
                    @click="flipTopCard(card.type)"
                  >
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i>
                    Daten aufklappen
                  </button>
                </div>

                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div style="text-align: left; font-size: 12px; font-family: karla;">
                        aktualisiert: {{ card.product.updated_time }}
                      </div>
                    </div>

                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span>
                          <span class="price">
                            {{ formatPreis(card.product.preisAmazonNeu) }} €
                          </span>
                          <br />
                        </div>

                        <a :href="card.product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                          <button class="btn13 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-back">
                <div class="card-body">
                  <TopThreeDatenblattMod
                    :key="'datenblatt-' + getCardInstanceId(card)"
                    :product="card.product"
                    :instance-id="'datenblatt-' + getCardInstanceId(card)"
                  />

                  <button class="datasheet-button" @click="flipTopCard(card.type)">
                    <i class="fa-solid fa-rotate-left icon-margin-right"></i>
                    Zurück zur Übersicht
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-12 col-lg-4 d-flex justify-content-center">
        <div class="rightBox">
          <div class="card2 text-center">
            <div class="card shadow-sm mb-4">
              <div class="row g-0">
                <div class="col-12 col-md-8 col-lg-12">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <img
                        src="/wp-content/plugins/tv-berater/logo_small.png"
                        alt="User Avatar"
                        class="rounded-circle me-3"
                        style="width: 40px; height: 40px; border: 2px solid #ccc;"
                      >
                      <h4 class="h6 mb-0 text-secondary fw-semibold text-start">
                        Wieso diese Fernseher zu dir passen?
                      </h4>
                    </div>

                    <p class="text-muted small mb-2 text-start">Deine persönliche Auswahl</p>

                    <div class="d-grid gap-3">
                      <div
                        v-for="(text, idx) in explanations"
                        :key="idx"
                        class="p-3 rounded shadow-sm bg-success bg-opacity-10 hover-shadow transition"
                      >
                        <p class="small mb-0" style="color: #15803d">
                          {{ text }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-share">
              <div class="card-body text-center">
                <h3 class="h6 mb-3">Ergebnis teilen</h3>
                <p class="text-muted small mb-4">
                  Teile jetzt deine persönliche TV-Auswahl mit Freunden, Bekannten oder Kollegen!
                </p>

                <div class="mt-1 mb-3 d-flex justify-content-center gap-3">
                  <a :href="whatsappUrl" target="_blank" rel="noopener">
                    <i class="bi bi-whatsapp share-icon whatsapp"></i>
                  </a>

                  <a :href="redditUrl" target="_blank" rel="noopener">
                    <i class="bi bi-reddit share-icon reddit"></i>
                  </a>

                  <a :href="twitterUrl" target="_blank" rel="noopener">
                    <i class="bi bi-twitter share-icon twitter"></i>
                  </a>

                  <a :href="facebookUrl" target="_blank" rel="noopener">
                    <i class="bi bi-facebook share-icon facebook"></i>
                  </a>

                  <a :href="emailUrl">
                    <i class="bi bi-envelope share-icon email"></i>
                  </a>

                  <div class="copy-link-wrapper position-relative d-inline-block">
                    <div
                      v-if="copied"
                      class="copy-notification position-absolute top-0 start-50 translate-middle-x bg-dark text-white px-2 py-1 rounded"
                      style="white-space: nowrap;"
                    >
                      Link zum Teilen kopiert!
                    </div>

                    <button @click="copyLink" class="btn p-0">
                      <i class="bi bi-clipboard share-icon clipboard"></i>
                    </button>
                  </div>
                </div>

                <button @click="$emit('reset')" class="datasheet-button">
                  Neue Beratung starten
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import TopThreeDatenblattMod from "./TopThreeDatenblattMod.vue";
import PicCarousel from "./PicCarousel.vue";

export default {
  components: {
    TopThreeDatenblattMod,
    PicCarousel,
  },

  props: {
    lowestPrice: { type: Object, required: true },
    bestRating: { type: Object, required: true },
    bestAmazon: { type: Object, required: true },
    detailsContent: { type: Array, default: () => [] },
    explanations: { type: Array, default: () => [] },
    example: { type: Boolean, default: false },
    shareableLink: { type: String, default: null },
  },

  emits: [
    "generate-share",
    "copy-share",
    "reset",
  ],

  data() {
    return {
      openIndex: 0,
      copied: false,
      _timeoutId: null,
      flippedTopCards: [],
      chartInstances: [],
    };
  },

  created() {
    if (!this.shareableLink) {
      this.$emit("generate-share");
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.renderTopCharts();
    });
  },

  beforeUnmount() {
    this.destroyTopCharts();

    if (this._timeoutId) {
      clearTimeout(this._timeoutId);
    }
  },

  watch: {
    topCards: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.renderTopCharts();
        });
      },
    },
  },

  computed: {
    topCards() {
      return [
        {
          type: "lowest",
          ribbon: "Kleinster Preis",
          product: this.lowestPrice,
        },
        {
          type: "rating",
          ribbon: "Höchste Bewertung",
          product: this.bestRating,
        },
        {
          type: "amazon",
          ribbon: "PL-Sieger",
          product: this.bestAmazon,
        },
      ].filter(card => card.product);
    },

    twitterUrl() {
      const url = encodeURIComponent(this.shareableLink || "");
      const text = encodeURIComponent("Schau dir meine TV-Empfehlungen an!");
      return `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
    },

    whatsappUrl() {
      const msg = encodeURIComponent(
        "Schau dir meine TV-Empfehlungen an: " + (this.shareableLink || "")
      );
      return `https://api.whatsapp.com/send?text=${msg}`;
    },

    facebookUrl() {
      const url = encodeURIComponent(this.shareableLink || "");
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    },

    redditUrl() {
      const url = encodeURIComponent(this.shareableLink || "");
      const title = encodeURIComponent("Meine TV-Empfehlungen");
      return `https://www.reddit.com/submit?url=${url}&title=${title}`;
    },

    emailUrl() {
      const subject = encodeURIComponent("TV-Empfehlungen für dich");
      const body = encodeURIComponent(
        `Hallo,

schau dir mal diese TV-Auswahl an:
${this.shareableLink || ""}

Viele Grüße!`
      );

      return `mailto:?subject=${subject}&body=${body}`;
    },
  },

  methods: {
    getProductId(product) {
      return String(
        product?.id ??
        product?.asin ??
        product?.amazon_url ??
        product?.amazonNamenSuche ??
        ""
      );
    },

    getCardInstanceId(card) {
      return `top-three-${card.type}-${this.getProductId(card.product)}`
        .replace(/[^A-Za-z0-9_-]/g, "-");
    },

    async copyLink() {
      try {
        const url = this.shareableLink || window.location.href;
        await navigator.clipboard.writeText(url);

        this.copied = true;

        if (this._timeoutId) {
          clearTimeout(this._timeoutId);
        }

        this._timeoutId = setTimeout(() => {
          this.copied = false;
          this._timeoutId = null;
        }, 2000);

        this.$emit("copy-share", url);
      } catch (err) {
      }
    },

    formatPreis(preis) {
      if (!preis) return "";

      return parseFloat(preis).toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    flipTopCard(type) {
      const id = String(type);
      const cardIndex = this.flippedTopCards.indexOf(id);

      if (cardIndex === -1) {
        this.flippedTopCards.push(id);
      } else {
        this.flippedTopCards.splice(cardIndex, 1);
      }
    },

    isTopCardFlipped(type) {
      return this.flippedTopCards.includes(String(type));
    },

    handleSummaryClick(index) {
      this.openIndex = this.openIndex === index ? -1 : index;
    },

    destroyTopCharts() {
      this.chartInstances.forEach(chart => {
        if (chart && typeof chart.destroy === "function") {
          chart.destroy();
        }
      });

      this.chartInstances = [];
    },

    renderTopCharts() {
      this.destroyTopCharts();

      this.topCards.forEach(card => {
        const canvas = document.getElementById(`chart-${this.getCardInstanceId(card)}`);

        if (!canvas) {
          return;
        }

        const ctx = canvas.getContext("2d");

        if (!ctx) {
          return;
        }

        const chart = this.renderChartTop(ctx, card.product);

        if (chart) {
          this.chartInstances.push(chart);
        }
      });
    },

    renderChartTop(ctx, prod) {
      const drawCategoryLabels = {
        id: `drawCategoryLabels-${Math.random().toString(36).slice(2)}`,
        afterDatasetsDraw(chart) {
          const ctx = chart.ctx;
          ctx.save();
          ctx.font = "16px Arial";
          ctx.fillStyle = "#000";
          ctx.textAlign = "left";
          ctx.textBaseline = "bottom";

          const meta0 = chart.getDatasetMeta(0);

          chart.data.labels.forEach((label, i) => {
            const bar = meta0.data[i];
            const x = chart.chartArea.left;
            const y = bar.y - (bar.height / 2);
            ctx.fillText(label, x, y);
          });

          ctx.restore();
        },
      };

      return new Chart(ctx, {
        type: "bar",
        data: {
          labels: ["Gaming", "Filme", "Sport"],
          datasets: [
            {
              data: [10, 10, 10],
              backgroundColor: "rgba(237, 237, 237, 0.3)",
              barThickness: 25,
              borderRadius: 25,
              borderWidth: 0.8,
              borderColor: "#333",
              borderSkipped: false,
              order: 0,
              grouped: false,
              categoryPercentage: 1,
              barPercentage: 1,
            },
            {
              data: [
                Number(prod?.videogameval || 0).toFixed(1),
                Number(prod?.hdrvideoval || 0).toFixed(1),
                Number(prod?.sportsval || 0).toFixed(1),
              ].map(Number),
              backgroundColor: [
                "rgba(255, 166, 166, 1)",
                "rgba(166, 188, 255, 1)",
                "rgba(255, 253, 125, 1)",
              ],
              borderColor: "#333",
              borderWidth: { top: 1, bottom: 1, left: 0, right: 1 },
              barThickness: 25,
              borderRadius: 10,
              borderSkipped: false,
              order: 1,
              grouped: false,
              categoryPercentage: 1,
              barPercentage: 1,
              datalabels: {
                display: true,
                anchor: "center",
                align: "right",
                color: "#333",
                font: { size: 20 },
                clamp: false,
              },
            },
          ],
        },

        plugins: [ChartDataLabels, drawCategoryLabels],

        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: { padding: { left: 20, right: 20, top: 10 } },
          indexAxis: "y",
          plugins: {
            legend: { display: false },
            tooltip: { filter: item => item.datasetIndex === 1 },
            datalabels: {
              display: ctx => ctx.datasetIndex === 1,
              anchor: "center",
              align: "right",
              color: "#333",
              font: { size: 18 },
              clamp: false,
            },
          },
          scales: {
            y: { display: false },
            x: { display: false, min: 0, max: 10 },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.top-three-product-card {
  height: auto !important;
  min-height: 650px;
  overflow: visible;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  position: relative;
}

.top-three-product-card .card-front {
  height: auto !important;
  min-height: 650px;
  backface-visibility: hidden;
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
}

.top-three-product-card .card-back {
  position: absolute;
  inset: 0;
  width: 100%;
  min-height: 100%;
  backface-visibility: hidden;
  background-color: #fff;
  border-radius: 10px;
  transform: rotateY(180deg);
  overflow: auto;
}

.top-three-product-card.is-flipped {
  transform: rotateY(180deg);
}

.top-three-carousel {
  height: 255px;
  min-height: 255px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.top-three-carousel :deep(.splide) {
  max-width: 270px;
  margin-left: auto;
  margin-right: auto;
}

.top-three-carousel :deep(img) {
  max-height: 205px;
  object-fit: contain;
}

.chart-container {
  height: 150px;
  min-height: 150px;
  margin: 0 6px 10px;
}

.ribbon-wrapper {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 10;
}

.ribbon {
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #040404;
  text-align: center;
  line-height: 20px;
  transform: rotate(45deg);
  position: relative;
  padding: 7px 0;
  left: -5px;
  top: 45px;
  width: 200px;
  background-color: rgb(155 220 134 / 39%);
  border: 0.8px solid;
}

.label-data-front {
  color: #999;
}

.btn13 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
}

.icon-margin-right {
  margin-right: 8px;
}

.rightBox {
  width: 60%;
}

.rightBox .card2 {
  margin-top: 5px;
}

.card.card-share {
  background: linear-gradient(
    120deg,
    #fcf5eb2e 0%,
    #f0ebe5 50%,
    #e6e1dc8f 100%
  );
}

.share-icon {
  font-size: 1.5rem;
  transition: opacity 0.2s;
}

.share-icon:hover {
  opacity: 0.8;
}

.twitter {
  color: #1DA1F2;
}

.facebook {
  color: #1877F2;
}

.whatsapp {
  color: #25D366;
}

.reddit {
  color: #FF4500;
}

.email {
  color: #EA4335;
}

.clipboard {
  color: #6c757d;
}

@media (max-width: 576px) {
  .rightBox {
    width: 100%;
    padding: 0 1rem;
  }

  .top-three-product-card {
    min-height: auto;
  }

  .top-three-product-card .card-front {
    min-height: auto;
  }
}
</style>
